import { useState } from 'react';
export const useGetScrollWidth = ({ pathname }) => {
    const [width, setWidth] = useState(0);
    const enableHorizontalScroll = ['/publisher', '/library', '/bookmarks'].includes(pathname.toLowerCase()) ||
        ['/publisher'].includes(pathname.toLowerCase());
    const onLayout = (e) => {
        // @ts-ignore
        const { target } = e.nativeEvent;
        setWidth(target.scrollWidth);
    };
    return {
        onLayout,
        width,
        enableHorizontalScroll,
    };
};
export default useGetScrollWidth;
//# sourceMappingURL=useGetScrollWidth.js.map